/* eslint-disable no-underscore-dangle */
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { fullStoryIntegration } from '@sentry/fullstory';
import { FullStory, init as initFullStory } from '@fullstory/browser';
import { AuthProvider as XometryAuthProvider } from '@xometry/auth-context';

import {
  API_ORIGIN,
  AUTH_ORIGIN,
  WWW_ORIGIN,
  GRAPHQL_ORIGIN,
  FULLSTORY_DEV_MODE,
  FULLSTORY_ORG_ID,
  SENTRY_BASE_URL,
  SENTRY_DSN,
  BASE_DOMAIN,
} from './config';
import App from './App';

if (SENTRY_DSN) {
  const fullStoryOverrideIntegration = () => {
    const original = fullStoryIntegration('xometry', {
      client: FullStory,
      baseSentryUrl: SENTRY_BASE_URL,
    });
    return {
      name: 'SentryFullStoryFilter',
      setupOnce: () => {},
      async processEvent(
        event: Sentry.Event,
        hint: Sentry.EventHint
      ): Promise<Sentry.Event | null> {
        if (hint?.originalException && original.processEvent) {
          return original.processEvent(event, hint);
        }
        return event;
      },
    };
  };
  initFullStory(
    {
      devMode: FULLSTORY_DEV_MODE,
      orgId: FULLSTORY_ORG_ID,
    },
    () => {
      Sentry.init({
        dsn: SENTRY_DSN,
        environment: BASE_DOMAIN.includes('stage') ? 'stage' : 'prod',
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: true,
            networkDetailAllowUrls: [API_ORIGIN, WWW_ORIGIN],
          }),
          fullStoryOverrideIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [API_ORIGIN, WWW_ORIGIN],
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
      });
    }
  );
}

ReactDOM.render(
  <XometryAuthProvider
    config={{
      authOrigin: AUTH_ORIGIN,
      graphqlOrigin: GRAPHQL_ORIGIN,
      apiOrigin: API_ORIGIN,
      includePartner: true,
      includePartnerId: true,
      graphqlEndpoint: '/graphql/',
      wundergraphPartnerUrl: `${WWW_ORIGIN}/graphql/federation/partner`,
      userFields: 'firstName lastName emailAddress',
    }}
  >
    <App />
  </XometryAuthProvider>,
  document.getElementById('main')
);
